module.exports = __webpack_public_path__ + "static/media/face2b.942ffb3a.jpg";